module.exports = __webpack_public_path__ + "static/media/franprix.30b0527b.png";